import api from "@/tools/Api";
import urls from "@/tools/Urls";

export default {
  globalAction() {
    console.log("it works");
  },
  async uploadImage(img, type = "personal", ...id) {
    try {
      // type = personal | national | payment | certificate/id
      return await api.post(urls.api(`upload_${type}_image`, [id]), img);
    } catch (e) {
      console.log(e);
    }
  },
};
